import { commonDateParamMappings } from '../../api/common/mappings';
import { standardQuerySerializer } from '../../api/serializers';
import { applyQueryConfig, makeCancelable, ServiceHandler } from '../../utils';

const getInsightsParamsMapping = [
  ...commonDateParamMappings,
  { path: 'page' },
  { path: 'size' },
  { path: 'search' },
  { path: 'accountId' },
  { path: 'recommendationTab' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      switch (orderBy) {
        case 'maxScore':
        case 'modified':
        case 'importance':
        case 'created':
          return `${orderBy},${order}`;
        default:
          return orderBy ? `${orderBy}.keyword,${order}` : null;
      }
    },
  },
];

const getInsightsHandler = makeCancelable(
  ServiceHandler({
    url: '/api/risk/v1/recommendations/all',
    paramsSerializer: (params) =>
      standardQuerySerializer(applyQueryConfig(getInsightsParamsMapping, params)),
  })
);
export const getInsights = (params: Record<string, unknown> = {}) =>
  getInsightsHandler({ params });

const getRiskHandler = makeCancelable(
  ServiceHandler({ url: `/api/risk/v1/factors/:accountId` })
);
export const getRisk = ({ accountId }: { accountId: string | number }) =>
  getRiskHandler(accountId);
